import { t } from "i18next";

export namespace CodingView {
  export enum Enum {
    Compact = "compact",
    Standard = "standard",
    Spreadsheet = "spreadsheet",
  }

  export const param = "view";
  export const defaultValue = Enum.Compact;

  export const fromString = (string: string): Enum =>
    Object.values(Enum).includes(string as Enum)
      ? (string as Enum)
      : defaultValue;

  export const getLabel = (view: Enum) => t(`coding:view.${view}`);
}
